import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccessioningListComponent } from './accessioning-list/accessioning-list.component';
import { EchoListComponent } from './echo-list/echo-list.component';
import { HomeComponent } from './home/home.component';
import { IsolationListComponent } from './isolation-list/isolation-list.component';
import { LysingListComponent } from './lysing-list/lysing-list.component';
import { TprepListComponent } from './tprep-list/tprep-list.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { ErrorComponent } from './error/error.component';
import { TrackerComponent } from './tracker/tracker.component';
import { ConfigComponent } from './config/config.component';
import { LabMapComponent } from './lab-map/lab-map.component';
import { MachineDetailComponent } from './machine-detail/machine-detail.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OpsAppRoutingModule } from './ops-app/ops-app-routing.module';
import { OpsAppShellComponent } from './ops-app/ops-app-shell/ops-app-shell.component';
import { InstrudexUserGuard } from './guards/instrudex-user.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

const routes: Routes = [
  { path: 'accessioning-list', component: AccessioningListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'config', component: ConfigComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'echo-list', component: EchoListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'isolation-list', component: IsolationListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'error', component: ErrorComponent },
  { path: 'lysing-list', component: LysingListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'lab-map', component: LabMapComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'machine-detail/:name', component: MachineDetailComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'tprep-list', component: TprepListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'tracker', component: TrackerComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'ops-app', component: OpsAppShellComponent, loadChildren: ()=> OpsAppRoutingModule },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '', redirectTo: 'ops-app', pathMatch: 'full' },
  { path: '**', redirectTo: 'config' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
